export default "__VITE_ASSET__CBUooMJB__"